export const withQuery = (query: Record<string, boolean | number | string> = {}) => (path: string) =>
  query && Object.entries(query)
    ? `${path}?`.concat(
        Object.entries(query)
          .reduce(
            (acc, [queryParam, value]) => [...acc, value ? `${queryParam}=${encodeURI(value.toString())}` : ''],
            [] as string[]
          )
          .join('&')
      )
    : path
